import './style.scss'

function DBSelectFilter({icon, placeholder, value, onChange, className = '', data = [], onClickIcon}) {
  return (
    <div className={`DBSelectFilter ${className}`}>
      {icon ?
        <div className={`DBSelectFilter-box ${onClickIcon ? 'DBSelectFilter-onClick' : ''}`} onClick={onClickIcon}>
          {icon}
        </div>
        : null}
      <select
        value={value}
        placeholder="test"
        className="DBSelectFilter-select"
        onChange={onChange}>
        {placeholder ?
          <option selected disabled>{placeholder}</option>
          : null}
        {data.map((item, index) => {
          return (
            <option key={index} value={item?.value}>{item?.title}</option>
          )
        })}
      </select>
    </div>
  );
}

export default DBSelectFilter;
